module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="filterRow">\n    <select class="filterSelect" aria-label="Champ à filtrer">\n    </select>\n    <select class="operation" aria-label="Opérateur du filtre">\n    </select>\n    <div class="picker">\n    </div>\n</div>';

}
return __p
}